import { Box, Header } from "@amzn/awsui-components-react";
import * as React from "react";
import { Toggle, TokenGroup } from "@amzn/awsui-components-react";
import { UIModel } from "../../model/ui-model";
import { AdminPreferences } from "@amzn/ask-legal-domain";
import { loadComponent } from "@amzn/legal-client-utilities";
import { AppContext } from "../../setup/context";
import { SourceMfePreloader } from "./SourceMfePreloader";

type InstanceSelection = React.ComponentType<{onSelected: (s) => void}>;

export const SourceInstanceSelect = (props: {
    editing: boolean;
    state: UIModel.State<AdminPreferences.SourceInstanceRef[]>;
}) => {
    const [enable, setEnable] = React.useState(false);
    const context = React.useContext(AppContext);
    const remoteEntryUrl = `${context.config.source.url}/remoteEntry.js`;

    const SourceInstanceSelectionMFE: InstanceSelection = React.lazy(() =>
        loadComponent("source2_provider", "./InstanceSelection", remoteEntryUrl , false)
    );

    window["remotes"] = {
        source2_provider: remoteEntryUrl
    };

    return (
        <div>
            <Header variant="h3">
                Source Integration
            </Header>
            <Box margin={{ "top": "xs" }}>
                <p>The Source integration allows users to search across Source to surface the results inside PathFinder. Once enabled users will see two tabs on the search results page, one tab for PathFinder results and another tab for Source results, users will only see results from Source that they have permission to see.</p>
                {!props.editing && <>
                    <Toggle
                        disabled={true}
                        checked={props.state?.value?.length}
                    >
                        Enable Source Search
                    </Toggle>
                    <br />
                    <Box variant="awsui-key-label">Instance Selection</Box>
                    <TokenGroup
                        readOnly
                        items={props.state.value?.map(i => ({label: i.name}))}
                    />
                </>}
                {props.editing && <>
                    <Toggle
                        onChange={({ detail }) => {
                            setEnable(detail.checked);
                            if (!detail.checked) {
                                props.state.setValue([]);
                            }
                        }}
                        checked={enable || props.state.value?.length}
                    >
                        Enable Source Search
                    </Toggle>
                    <br />
                    <Box variant="awsui-key-label">Instance Selection</Box>
                    {!!props.state.value?.length && (
                        <TokenGroup
                            onDismiss={({ detail: { itemIndex } }) => {
                                props.state.setValue([
                                ...props.state.value?.slice(0, itemIndex),
                                ...props.state.value?.slice(itemIndex + 1)
                                ]);
                            }}
                            items={props.state.value?.map(i => ({label: i.name}))}
                        />
                    )}
                    {!!!props.state.value?.length && (
                        <>
                            {enable &&
                                <SourceMfePreloader>
                                    <React.Suspense fallback={<div>Loading...</div>}>
                                        <SourceInstanceSelectionMFE
                                            onSelected={
                                                (s) => {
                                                    props.state.setValue([s]);
                                                }
                                            }
                                        />
                                    </React.Suspense>
                                </SourceMfePreloader>
                            }
                        </>
                    )}
                </>}
            </Box>
        </div>
    );
};
